import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Check = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M4.641 11.231l-1.282 1.538 6.769 5.639L20.769 5.641l-1.538-1.282-9.359 11.233z", key: "k0" })));
});
Check.displayName = 'Check';
export var CheckDimensions = { height: 24, width: 24 };
